import { CloneHelper } from "../../helpers/clone";
import { IdHelper } from "../../helpers/id";
import { GenericDamage } from "../../ts/visualModel";

export class GenericDamageMapper {
  /** Creates new damage based on the source/original damage. */
  public static mapToNew<TDamage extends GenericDamage>(
    source: TDamage,
    dest?: Partial<GenericDamage>,
  ): TDamage {
    const dest2: TDamage = {
      ...CloneHelper.cloneDeep(source),
      ...dest,
      // reset or redefine all identifiable fields
      id: IdHelper.newTempFeId(),
      originalId: source.id,
      originalIds: null,
      localNumber: null,
      vehicleDamageId: null,
      vehicleDamage: null,
    };
    return dest2;
  }
}
